export default function(visibility) {
    if (!visibility || !visibility.id) return "This is a public mention";

    switch (visibility.id) {
        case "DIRECT_MESSAGE": return "This is a direct message";
        case "INTERNAL": return "This is private, internal communications";
        case "EMAIL": return "This is private email";
    }
    return visibility.label;
}